import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Image, Button } from "react-bootstrap";
import { MESSAGE } from "../../../utils/message";
import Category_Not_Found from "../../../assests/images/category-not-found.svg"
import {
    NotFoundBox,
    NotFoundImage,
    NotFoundText,
    NotFoundButton,
    NotFoundTitle, 
    NotFoundBoxInner,
    NotFoundCategoryTitle,
    NotFoundCategoryText,
} from "./notFoundCampStyle"
import { useNavigate } from "react-router-dom";

interface Props {
    selectedCity: string|undefined;
    selectedCategory:string|undefined;
}
const NotFoundCamp = ({selectedCity,selectedCategory}:Props) => {
    const navigate = useNavigate()
    return (<>
        <NotFoundBox as={Col} sm="12">
            <NotFoundBoxInner>
                <NotFoundImage>
                    <Image src={Category_Not_Found} alt="" width="" height="" />
                </NotFoundImage>
                <NotFoundText>
                    <NotFoundTitle>{MESSAGE.notFoundTitle(selectedCity,selectedCategory)}</NotFoundTitle>
                </NotFoundText>
                <NotFoundButton>
                    <Button className="btn-outline-success-blue" onClick={() => {typeof localStorage !=="undefined"&&localStorage.removeItem("search");navigate('/organizations/browse')}} >{MESSAGE.viewAll}</Button>
                </NotFoundButton>
            </NotFoundBoxInner>
        </NotFoundBox>
        <NotFoundCategoryTitle>
            <NotFoundCategoryText>{MESSAGE.notFoundCategoryTitle}</NotFoundCategoryText>
        </NotFoundCategoryTitle>
    </>)
};
export default NotFoundCamp;